<template>
  <div class="user-container">
    <div class="table-field-list">
      <el-row class>
        <label>文章标题:</label>
        <el-input style="width:200px;" v-model="params.title" placeholder="请输入内容"></el-input>
        <label style="margin:0 30px;">开始日期:</label>
        <el-date-picker
          v-model="params.startTime"
          align="right"
          type="date"
          placeholder="选择开始日期"
          style="width:150px;"
        ></el-date-picker>
        <label style="margin:0 30px;">结束日期:</label>
        <el-date-picker
          v-model="params.endTime"
          align="right"
          type="date"
          placeholder="选择结束日期"
          style="width:150px;"
        ></el-date-picker>
      </el-row>

      <el-row>
        <label>文章类别:</label>
        <el-select v-model="params.typeId" placeholder="请选择">
          <el-option v-for="item in types" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <label style="margin:0 30px;">发布状态:</label>
        <el-select v-model="params.status" placeholder="请选择">
          <el-option label="未发布" value="1"></el-option>
          <el-option label="已发布" value="2"></el-option>
          <el-option label="已下架" value="3"></el-option>
        </el-select>
        <el-button style="margin:0 30px;" type="primary" @click="handleSearch">搜索</el-button>
      </el-row>
    </div>
    <el-table
      :data="tableData"
      :row-style="{height:'30px'}"
      :cell-style="{padding:'5px 0'}"
      style="width: 100%"
      height="580px"
      :border="true"
      :header-cell-style="{background: '#f2f2f2'}"
    >
      <el-table-column label="标题" width="180">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="light" :content="scope.row.title" placement="top">
            <div
              :style="{ textDecoration:`underline`,overflow: `hidden`,textOverflow:`ellipsis`,whiteSpace: `nowrap` }"
            >{{ scope.row.title }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="userName" label="作者"></el-table-column>
      <el-table-column prop="typeName" label="类别"></el-table-column>
      <el-table-column prop="readingTime" label="阅读次数"></el-table-column>
      <el-table-column prop="writeTime" label="编辑日期" width="180"></el-table-column>
      <el-table-column prop="expRelTime" label="预发布时间" width="180"></el-table-column>
      <el-table-column prop="createTime" label="创建日期" width="180"></el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === `1`" type="danger">未发布</el-tag>
          <el-tag v-if="scope.row.status === `2`" type="success">已发布</el-tag>
          <el-tag v-if="scope.row.status === `3`" type="warning">已下架</el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" width="280" label="操作">
        <template slot-scope="scope">
          <el-button
            @click="handleClickPush(scope.row.id)"
            type="success"
            size="mini"
            icon="el-icon-caret-right"
            v-if="scope.row.status   !== `2` "
          >发布</el-button>
          <el-button
            type="primary"
            icon="el-icon-edit"
            @click="handlEidt(scope.row.id)"
            size="mini"
          >编辑</el-button>
          <el-button
            type="danger"
            icon="el-icon-edit"
            @click="handlDelete(scope.row.id)"
            v-if="scope.row.status === `2`"
            size="mini"
          >下架</el-button>
          <router-link target="_blank" :to="{path:'/detail',query:{id: scope.row.id}}">
            <el-button type="primary" icon="el-icon-share" size="mini">预览</el-button>
          </router-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-size="params.limit"
      :current-page="params.page"
      style="margin-top:30px;"
      background
      layout="total,prev, pager, next"
      :total="total"
      @current-change="handleClickPage"
    ></el-pagination>
  </div>
</template>

<script>
import { newsList, artTyple, pushArticle, deleteArticle } from "@/axios/api";
export default {
  data() {
    return {
      tableData: [],
      params: {
        page: 1,
        limit: 30,
        title: "",
        startTime: "",
        endTime: "",
        typeId: "",
        status: ""
      },
      total: 0,
      types: []
    };
  },
  methods: {
    handlEidt(id) {
      this.$router.push({ path: "/Main/news/edit", query: { id: id } });
    },
    handlDelete(id) {
      deleteArticle({ id: id }).then(res => {
        if (res.status === 200) {
          this.$message("下架成功");
          this.handleNewsList();
        }
      });
    },
    handleClickPush(id) {
      pushArticle({ id: id }).then(res => {
        if (res.status === 200) {
          this.$message("发布成功");
          this.handleNewsList();
        }
      });
    },
    handleSearch() {
      this.params.page = 1;
      this.handleNewsList();
    },
    handleNewsList() {
      newsList(this.params).then(res => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    handleClickPage(event) {
      this.params.page = event;
      this.handleNewsList();
    },
    getArtTyple() {
      artTyple().then(res => {
        if (res.status === 200) this.types = res.data;
      });
    }
  },
  mounted() {
    this.handleNewsList();
    this.getArtTyple();
  }
};
</script>

<style>
.table-field-list .el-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.table-field-list {
  width: 100%;
  height: 180px;
  border: 1px solid #ebebeb;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 50px;
  box-sizing: border-box;
  padding: 30px;
}
.user-container {
  width: 100%;
  height: auto;
  position: relative;
}
</style>


// WEBPACK FOOTER //
// src/views/news/News.vue